// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Switch club — same glass language as the home welcome card. */

.switch-club-dialog .MuiBackdrop-root {
  background: color-mix(in srgb, var(--bg-color, #0b0f19) 46%, transparent) !important;
  backdrop-filter: blur(18px) saturate(1.15);
  -webkit-backdrop-filter: blur(18px) saturate(1.15);
}

.switch-club-dialog .MuiDialog-container {
  align-items: center;
}

.switch-club-dialog .MuiPaper-root.switch-club-dialog__paper {
  --switch-club-font: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display",
    "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  position: relative;
  display: flex;
  flex-direction: column;
  width: min(440px, calc(100vw - 28px));
  max-width: min(440px, calc(100vw - 28px)) !important;
  max-height: min(78vh, 640px);
  margin: 16px;
  padding: 0;
  overflow: hidden;
  border-radius: 20px !important;
  color: var(--text-color, #111827);
  background:
    linear-gradient(
      165deg,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16) 0%,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04) 42%,
      transparent 72%
    ),
    color-mix(in srgb, var(--surface-color, #fff) 90%, transparent) !important;
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, rgba(0, 0, 0, 0.08)));
  box-shadow:
    0 24px 64px var(--shadow-color, rgba(8, 18, 32, 0.18)),
    0 2px 8px rgba(8, 18, 32, 0.06) !important;
  font-family: var(--switch-club-font) !important;
  animation: switchClubIn 0.38s cubic-bezier(0.25, 1, 0.5, 1) both;
}

.switch-club-dialog .MuiPaper-root.switch-club-dialog__paper,
.switch-club-dialog .MuiPaper-root.switch-club-dialog__paper * {
  font-family: var(--switch-club-font) !important;
}

.dark-mode .switch-club-dialog .MuiPaper-root.switch-club-dialog__paper,
html.dark-mode .switch-club-dialog .MuiPaper-root.switch-club-dialog__paper {
  background:
    linear-gradient(
      165deg,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.26) 0%,
      rgba(15, 23, 42, 0.35) 42%,
      transparent 78%
    ),
    color-mix(in srgb, var(--surface-color, #111827) 86%, transparent) !important;
}

.switch-club-dialog__wash {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  background: linear-gradient(
    165deg,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18) 0%,
    transparent 72%
  );
}

.switch-club-dialog__header {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 16px 8px;
}

.switch-club-dialog__mark {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  margin-top: 2px;
  border-radius: 11px;
  background: linear-gradient(
    160deg,
    var(--brand-primary, #0877bc),
    color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #081018)
  );
  color: #fff;
  box-shadow: 0 8px 18px color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);
}

.switch-club-dialog__mark svg {
  width: 18px;
  height: 18px;
}

.switch-club-dialog__heading {
  min-width: 0;
  flex: 1 1;
  padding-right: 8px;
}

.switch-club-dialog__eyebrow {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  line-height: 1.2;
  color: var(--brand-primary, #0877bc);
}

.dark-mode .switch-club-dialog__eyebrow,
html.dark-mode .switch-club-dialog__eyebrow {
  color: var(--brand-primary-light, var(--brand-primary, #0a84ff));
}

.switch-club-dialog__title {
  margin: 2px 0 0;
  font-size: 1.2rem;
  font-weight: 750;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--text-color, #111);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.switch-club-dialog__prompt {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
  color: var(--text-secondary, #4b5563);
}

.switch-club-dialog__close {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  margin: 0;
  padding: 0;
  border-radius: 11px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  background: var(--surface-color, #fff);
  color: var(--text-secondary, #4b5563);
  box-shadow: 0 4px 10px var(--shadow-color, rgba(0, 0, 0, 0.06));
  cursor: pointer;
  transition:
    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    border-color 0.2s ease,
    color 0.2s ease;
}

.switch-club-dialog__close:hover:not(:disabled) {
  transform: translateY(-1px);
  color: var(--text-color, #111);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 40%, var(--border-color, transparent));
}

.switch-club-dialog__close:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.switch-club-dialog__close:disabled {
  opacity: 0.45;
  cursor: default;
}

.switch-club-dialog__close svg {
  width: 16px;
  height: 16px;
}

.switch-club-dialog__body {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  padding: 10px 14px 16px;
  overflow: auto;
}

.switch-club-dialog__banner {
  margin: 0;
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
}

.switch-club-dialog__banner--error {
  color: #9f1239;
  background: color-mix(in srgb, #e11d48 12%, var(--surface-color, #fff));
  border: 1px solid color-mix(in srgb, #e11d48 28%, transparent);
}

.switch-club-dialog__banner--success {
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color, #fff));
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
}

.dark-mode .switch-club-dialog__banner--error,
html.dark-mode .switch-club-dialog__banner--error {
  color: #fecdd3;
}

.switch-club-dialog__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.switch-club-dialog__club,
.switch-club-dialog__club-static {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  box-sizing: border-box;
  text-align: left;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--border-color, rgba(0, 0, 0, 0.08)));
  background: var(--surface-color, #fff);
  color: inherit;
  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);
  transition:
    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.switch-club-dialog__club {
  cursor: pointer;
}

.switch-club-dialog__club:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color, transparent));
  box-shadow: 0 10px 22px color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);
}

.switch-club-dialog__club:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.switch-club-dialog__club:disabled {
  cursor: wait;
  opacity: 0.72;
}

.switch-club-dialog__club.is-active,
.switch-club-dialog__club-static {
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 48%, var(--border-color, transparent));
  background:
    linear-gradient(
      120deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent) 0%,
      transparent 58%
    ),
    var(--surface-color, #fff);
}

.switch-club-dialog__logo,
.switch-club-dialog__initial {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-sizing: border-box;
}

.switch-club-dialog__logo {
  object-fit: contain;
  object-position: center;
  padding: 4px;
  background: var(--brand-surface, #fff);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
}

.switch-club-dialog__initial {
  display: grid;
  place-items: center;
  background: linear-gradient(
    160deg,
    var(--brand-primary, #0877bc),
    color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #081018)
  );
  color: #fff;
  font-size: 18px;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.switch-club-dialog__meta {
  min-width: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.switch-club-dialog__name {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--text-color, #111);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.switch-club-dialog__pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.switch-club-dialog__pill {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 7px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, transparent));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);
  color: var(--text-secondary, #4b5563);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1;
}

.switch-club-dialog__action {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 72px;
  height: 32px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1;
}

.switch-club-dialog__action--select {
  color: #fff;
  background: var(--brand-primary, #0877bc);
  box-shadow: 0 8px 16px -6px color-mix(in srgb, var(--brand-primary, #0877bc) 55%, transparent);
}

.switch-club-dialog__action--active {
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);
}

.dark-mode .switch-club-dialog__action--active,
html.dark-mode .switch-club-dialog__action--active {
  color: var(--brand-primary-light, var(--brand-primary, #0a84ff));
}

.switch-club-dialog__action svg {
  width: 14px;
  height: 14px;
}

.switch-club-dialog__spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  animation: switchClubSpin 0.7s linear infinite;
}

.switch-club-dialog__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 8px 0 12px;
  padding: 28px 12px;
  border-radius: 14px;
  border: 1px dashed color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color, transparent));
  color: var(--text-secondary, #4b5563);
  text-align: center;
}

.switch-club-dialog__empty p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary, #4b5563);
}

@keyframes switchClubIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes switchClubSpin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .switch-club-dialog .MuiPaper-root.switch-club-dialog__paper,
  .switch-club-dialog__club,
  .switch-club-dialog__close,
  .switch-club-dialog__spinner {
    animation: none !important;
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SwitchClubDialog.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,oFAAoF;EACpF,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;oDACkD;EAClD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,oDAAoD;EACpD,4BAA4B;EAC5B,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC;;;;;;;8EAO4E;EAC5E,2BAA2B;EAC3B,mCAAmC;EACnC,iHAAiH;EACjH;;8CAE4C;EAC5C,+CAA+C;EAC/C,gEAAgE;AAClE;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE;;;;;;;iFAO+E;AACjF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB;;;;GAIC;EACD,WAAW;EACX,yFAAyF;AAC3F;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;EAEE,gEAAgE;AAClE;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,0DAA0D;EAC1D,sCAAsC;EACtC,qCAAqC;EACrC,+DAA+D;EAC/D,eAAe;EACf;;;mBAGiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qGAAqG;AACvG;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,uEAAuE;EACvE,8DAA8D;AAChE;;AAEA;EACE,oCAAoC;EACpC,6FAA6F;EAC7F,oFAAoF;AACtF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iHAAiH;EACjH,sCAAsC;EACtC,cAAc;EACd,wFAAwF;EACxF;;;wBAGsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qGAAqG;EACrG,0FAA0F;AAC5F;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,qGAAqG;EACrG;;;;;;8BAM4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,oFAAoF;EACpF,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;;;;GAIC;EACD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yGAAyG;EACzG,6EAA6E;EAC7E,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,8FAA8F;AAChG;;AAEA;EACE,oCAAoC;EACpC,8EAA8E;AAChF;;AAEA;;EAEE,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0GAA0G;EAC1G,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;;;IAIE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":["/* Switch club — same glass language as the home welcome card. */\n\n.switch-club-dialog .MuiBackdrop-root {\n  background: color-mix(in srgb, var(--bg-color, #0b0f19) 46%, transparent) !important;\n  backdrop-filter: blur(18px) saturate(1.15);\n  -webkit-backdrop-filter: blur(18px) saturate(1.15);\n}\n\n.switch-club-dialog .MuiDialog-container {\n  align-items: center;\n}\n\n.switch-club-dialog .MuiPaper-root.switch-club-dialog__paper {\n  --switch-club-font: -apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"SF Pro Display\",\n    \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: min(440px, calc(100vw - 28px));\n  max-width: min(440px, calc(100vw - 28px)) !important;\n  max-height: min(78vh, 640px);\n  margin: 16px;\n  padding: 0;\n  overflow: hidden;\n  border-radius: 20px !important;\n  color: var(--text-color, #111827);\n  background:\n    linear-gradient(\n      165deg,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16) 0%,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04) 42%,\n      transparent 72%\n    ),\n    color-mix(in srgb, var(--surface-color, #fff) 90%, transparent) !important;\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, rgba(0, 0, 0, 0.08)));\n  box-shadow:\n    0 24px 64px var(--shadow-color, rgba(8, 18, 32, 0.18)),\n    0 2px 8px rgba(8, 18, 32, 0.06) !important;\n  font-family: var(--switch-club-font) !important;\n  animation: switchClubIn 0.38s cubic-bezier(0.25, 1, 0.5, 1) both;\n}\n\n.switch-club-dialog .MuiPaper-root.switch-club-dialog__paper,\n.switch-club-dialog .MuiPaper-root.switch-club-dialog__paper * {\n  font-family: var(--switch-club-font) !important;\n}\n\n.dark-mode .switch-club-dialog .MuiPaper-root.switch-club-dialog__paper,\nhtml.dark-mode .switch-club-dialog .MuiPaper-root.switch-club-dialog__paper {\n  background:\n    linear-gradient(\n      165deg,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.26) 0%,\n      rgba(15, 23, 42, 0.35) 42%,\n      transparent 78%\n    ),\n    color-mix(in srgb, var(--surface-color, #111827) 86%, transparent) !important;\n}\n\n.switch-club-dialog__wash {\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 120px;\n  background: linear-gradient(\n    165deg,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18) 0%,\n    transparent 72%\n  );\n}\n\n.switch-club-dialog__header {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 18px 16px 8px;\n}\n\n.switch-club-dialog__mark {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  margin-top: 2px;\n  border-radius: 11px;\n  background: linear-gradient(\n    160deg,\n    var(--brand-primary, #0877bc),\n    color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #081018)\n  );\n  color: #fff;\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);\n}\n\n.switch-club-dialog__mark svg {\n  width: 18px;\n  height: 18px;\n}\n\n.switch-club-dialog__heading {\n  min-width: 0;\n  flex: 1;\n  padding-right: 8px;\n}\n\n.switch-club-dialog__eyebrow {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  color: var(--brand-primary, #0877bc);\n}\n\n.dark-mode .switch-club-dialog__eyebrow,\nhtml.dark-mode .switch-club-dialog__eyebrow {\n  color: var(--brand-primary-light, var(--brand-primary, #0a84ff));\n}\n\n.switch-club-dialog__title {\n  margin: 2px 0 0;\n  font-size: 1.2rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--text-color, #111);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.switch-club-dialog__prompt {\n  margin: 4px 0 0;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.35;\n  color: var(--text-secondary, #4b5563);\n}\n\n.switch-club-dialog__close {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  margin: 0;\n  padding: 0;\n  border-radius: 11px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  background: var(--surface-color, #fff);\n  color: var(--text-secondary, #4b5563);\n  box-shadow: 0 4px 10px var(--shadow-color, rgba(0, 0, 0, 0.06));\n  cursor: pointer;\n  transition:\n    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    border-color 0.2s ease,\n    color 0.2s ease;\n}\n\n.switch-club-dialog__close:hover:not(:disabled) {\n  transform: translateY(-1px);\n  color: var(--text-color, #111);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 40%, var(--border-color, transparent));\n}\n\n.switch-club-dialog__close:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.switch-club-dialog__close:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.switch-club-dialog__close svg {\n  width: 16px;\n  height: 16px;\n}\n\n.switch-club-dialog__body {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 0;\n  padding: 10px 14px 16px;\n  overflow: auto;\n}\n\n.switch-club-dialog__banner {\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.switch-club-dialog__banner--error {\n  color: #9f1239;\n  background: color-mix(in srgb, #e11d48 12%, var(--surface-color, #fff));\n  border: 1px solid color-mix(in srgb, #e11d48 28%, transparent);\n}\n\n.switch-club-dialog__banner--success {\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color, #fff));\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n}\n\n.dark-mode .switch-club-dialog__banner--error,\nhtml.dark-mode .switch-club-dialog__banner--error {\n  color: #fecdd3;\n}\n\n.switch-club-dialog__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.switch-club-dialog__club,\n.switch-club-dialog__club-static {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin: 0;\n  padding: 10px 12px;\n  box-sizing: border-box;\n  text-align: left;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--border-color, rgba(0, 0, 0, 0.08)));\n  background: var(--surface-color, #fff);\n  color: inherit;\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);\n  transition:\n    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.switch-club-dialog__club {\n  cursor: pointer;\n}\n\n.switch-club-dialog__club:hover:not(:disabled) {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color, transparent));\n  box-shadow: 0 10px 22px color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);\n}\n\n.switch-club-dialog__club:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.switch-club-dialog__club:disabled {\n  cursor: wait;\n  opacity: 0.72;\n}\n\n.switch-club-dialog__club.is-active,\n.switch-club-dialog__club-static {\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 48%, var(--border-color, transparent));\n  background:\n    linear-gradient(\n      120deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent) 0%,\n      transparent 58%\n    ),\n    var(--surface-color, #fff);\n}\n\n.switch-club-dialog__logo,\n.switch-club-dialog__initial {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  box-sizing: border-box;\n}\n\n.switch-club-dialog__logo {\n  object-fit: contain;\n  object-position: center;\n  padding: 4px;\n  background: var(--brand-surface, #fff);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);\n}\n\n.switch-club-dialog__initial {\n  display: grid;\n  place-items: center;\n  background: linear-gradient(\n    160deg,\n    var(--brand-primary, #0877bc),\n    color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #081018)\n  );\n  color: #fff;\n  font-size: 18px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.switch-club-dialog__meta {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.switch-club-dialog__name {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--text-color, #111);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.switch-club-dialog__pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.switch-club-dialog__pill {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  padding: 0 7px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color, transparent));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);\n  color: var(--text-secondary, #4b5563);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.switch-club-dialog__action {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-width: 72px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  line-height: 1;\n}\n\n.switch-club-dialog__action--select {\n  color: #fff;\n  background: var(--brand-primary, #0877bc);\n  box-shadow: 0 8px 16px -6px color-mix(in srgb, var(--brand-primary, #0877bc) 55%, transparent);\n}\n\n.switch-club-dialog__action--active {\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);\n}\n\n.dark-mode .switch-club-dialog__action--active,\nhtml.dark-mode .switch-club-dialog__action--active {\n  color: var(--brand-primary-light, var(--brand-primary, #0a84ff));\n}\n\n.switch-club-dialog__action svg {\n  width: 14px;\n  height: 14px;\n}\n\n.switch-club-dialog__spinner {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #fff;\n  animation: switchClubSpin 0.7s linear infinite;\n}\n\n.switch-club-dialog__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0 12px;\n  padding: 28px 12px;\n  border-radius: 14px;\n  border: 1px dashed color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color, transparent));\n  color: var(--text-secondary, #4b5563);\n  text-align: center;\n}\n\n.switch-club-dialog__empty p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary, #4b5563);\n}\n\n@keyframes switchClubIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes switchClubSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .switch-club-dialog .MuiPaper-root.switch-club-dialog__paper,\n  .switch-club-dialog__club,\n  .switch-club-dialog__close,\n  .switch-club-dialog__spinner {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
